import { compact } from 'lodash';
import { DownOutlined } from '@ant-design/icons';
import { Button, Dropdown, MenuProps, Space } from "antd";

import { Copy } from "./BulkActions/Copy";
import { Move } from "./BulkActions/Move";
import { Delete } from "./BulkActions/Delete";
import { Download } from "./BulkActions/Download";

import { Category, Document } from "interfaces/documents";
import { isDocument } from "../../../utilities/constants";

const ActionDropdown = ({
    fetchData,
    selected,
}: {
    fetchData: () => void,
    selected: (Category | Document)[],
}) => {
    const bulkDownload = Download(selected);
    const bulkMove = Move(selected, fetchData);
    const bulkDelete = Delete(selected, fetchData);
    const bulkCopy = Copy(selected.filter(item => isDocument(item)) as Document[], fetchData);

    const items: MenuProps['items'] = compact([
        bulkDownload,
        bulkCopy,
        bulkMove,
        bulkDelete,
    ]);

    if (items.length === 0) {
        return null;
    }

    return (
        <Dropdown menu={{ items }}>
            <Button>
                <Space>
                    Actions
                    <DownOutlined />
                </Space>
            </Button>
        </Dropdown>
    );
};

export default ActionDropdown;
